import { useState } from 'react';
import { useFlag } from '@/features/unleash';
import NotFound from '@/pages/NotFound';
import DocumentHeader from '@/components/DocumentHeader';
import { Form } from '@/components/NarrativeForm';
import {
  useCreateNarrative,
  type NarrativeCreationResponseData,
} from '../../hooks/useCreateNarrative';
import { CreateNarrativeRequest } from '@/components/NarrativeForm/types';
import useUser from '@/hooks/useUser';
import { authorHasNoPositionDisclaimer } from '@/components/NarrativeForm/components/Form/disclaimer';

export const CreateNarrative = () => {
  const [narrative, setNarrative] = useState<NarrativeCreationResponseData>();
  const { data: user } = useUser();
  const flag = useFlag({ name: 'mono-narrative-authoring' });

  const fields: CreateNarrativeRequest = {
    title: '',
    authorId: '',
    status: 'draft',
    visibility: 'private',
    companyId: '',
    currencyIso: '',
    valuations: [
      {
        title: 'Base Case',
        fairValue: 0,
        sharePriceAtPublish: 0,
        valuationByLine: '',
        valuatorToolLink: undefined,
        type: 'base',
        contentHtml: '',
      },
    ],
    contentBlocks: [
      { title: 'Key Takeaways', contentHtml: '' },
      { title: 'Catalysts', contentHtml: '' },
      { title: 'Assumptions', contentHtml: '' },
      { title: 'Risks', contentHtml: '' },
    ],
    userHoldsPosition: false,
    publishDate: new Date().toISOString(),
    coverImageUrl: '',
    disclaimer: authorHasNoPositionDisclaimer(user.name),
    companyCanonicalUrl: '',
  };
  const { mutate: createNarrative, status: createNarrativeStatus } =
    useCreateNarrative({
      onSuccess: (data?: NarrativeCreationResponseData) => {
        setNarrative(data);
      },
    });

  if (!user.loggedIn || !flag.flagsReady || !flag.enabled) {
    return <NotFound />;
  }

  return (
    <>
      {narrative && (
        <h4>
          Narrative <strong>{narrative.slug}</strong> succesfully created!
        </h4>
      )}
      <DocumentHeader title="Create a Narrative" />
      <Form
        onSubmit={(params: CreateNarrativeRequest) => {
          createNarrative(params);
        }}
        status={createNarrativeStatus}
        narrative={fields}
      />
    </>
  );
};
